export default __webpack_public_path__ + "static/media/icon1.a93c32e1.svg";